/* HanysLux PDP — gallery swap, variant resolver, sticky ATC. Loaded only on product templates.
   Add-to-cart itself is handled by hl-home.js (intercepts the form → /cart/add.js → opens drawer). */

/* ── STICKY GALLERY OFFSET ────────────────────────────────────────────────────────────────────
   `.gallery` is position:sticky. Its `top` used to be a flat 90px, tuned back when the header
   did not actually stick (its section wrapper gave it zero travel — see hl-base.css). Now that
   the countdown bar and header really do pin, a flat 90px parks the gallery UNDERNEATH them:
   measured 205.6px of pinned chrome vs a 90px offset left the top 115.6px of the product photo
   hidden behind the header.

   The CSS now reads `calc(var(--hl-cd-h,0px) + var(--hl-hdr-h,90px) + 1rem)`.
   `--hl-cd-h` is already owned and kept current by the countdown bar's own script — including
   being set to 0px when the bar is dismissed or expires — so it is deliberately NOT recomputed
   here; duplicating that ownership is how the two would drift apart. This block owns ONLY the
   header half, which the countdown script knows nothing about and which changes with the
   responsive breakpoint and with font swap-in.

   Separate IIFE on purpose: the main one below returns early when there is no product form, and
   this must run regardless of that. */
(function () {
  var hdr = document.querySelector('.hdr');
  if (!hdr || !document.querySelector('.gallery')) return;
  var root = document.documentElement;
  function syncHdr() { root.style.setProperty('--hl-hdr-h', hdr.offsetHeight + 'px'); }
  syncHdr();
  if (window.ResizeObserver) { new ResizeObserver(syncHdr).observe(hdr); }
  else { window.addEventListener('resize', syncHdr); }
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncHdr); }
})();
(function () {
  var form = document.querySelector('.hl-atc-form') || document.querySelector('form[action*="/cart/add"]');
  var dataEl = document.querySelector('[data-hl-variants]');
  if (!form || !dataEl) return;
  var variants = JSON.parse(dataEl.textContent || '[]');
  var idInput = form.querySelector('[data-variant-id]');
  var atc = form.querySelector('[data-hl-atc]');
  var mainImg = document.getElementById('mainImg');

  /* Gallery stage refs are declared HERE, not down beside the thumbnail handler, because
     update() runs before that point and calls showImage(). Function declarations hoist; `var`
     assignments do not — leaving these below would make the first update() throw on an
     undefined NodeList and kill the whole variant resolver with it. */
  var stage = document.querySelector('[data-gallery-main]');
  var videoWraps = stage ? stage.querySelectorAll('.gallery__video') : [];

  function pauseAll() {
    videoWraps.forEach(function (w) {
      var v = w.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
    });
  }

  function showImage() {
    if (mainImg) mainImg.hidden = false;
    videoWraps.forEach(function (w) { w.hidden = true; });
    pauseAll();
  }

  function showVideo(id) {
    if (mainImg) mainImg.hidden = true;
    videoWraps.forEach(function (w) {
      var match = w.getAttribute('data-media-id') === id;
      w.hidden = !match;
      var v = w.querySelector('video');
      if (!v) return;
      if (!match) { try { v.pause(); } catch (e) {} return; }
      /* Set muted in JS as well as in the Liquid: muted is the ONLY reason a browser will
         honour autoplay, and play() returns a promise that REJECTS if it is refused. Unhandled,
         that rejection surfaces as a console error and the clip sits frozen on frame 1 — with
         controls visible the shopper can still start it, so swallow it rather than throw. */
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  // current selected value per option group (in option order)
  var selected = [];
  form.querySelectorAll('.opt__btns').forEach(function (g, i) {
    var s = g.querySelector('.opt__btn.is-selected') || g.querySelector('.opt__btn');
    selected[i] = s ? s.getAttribute('data-value') : null;
  });

  function matchVariant() {
    return variants.find(function (v) {
      var opts = v.options || [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return opts[i] === val; });
    });
  }

  function setPrices(text) {
    document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = text; });
  }

  function update() {
    var v = matchVariant();
    if (v) {
      if (idInput) idInput.value = v.id;
      setPrices(money(v.price));
      if (v.featured_image && v.featured_image.src && mainImg) {
        showImage();   // a variant change returns the stage to the photo
        mainImg.src = v.featured_image.src;
        document.querySelectorAll('.thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full') && t.getAttribute('data-full').split('?')[0] === v.featured_image.src.split('?')[0]);
        });
      }
      setAvailability(v.available);
    } else {
      setAvailability(false);   // impossible option combo -> treat as unbuyable
    }
  }

  /* Sold-out must change the LABEL, not just grey the button — a faded "Add to cart" reads as
     a broken button, not as out of stock. Mirrors the server-side render in product.liquid. */
  var atcAdd = atc && atc.querySelector('[data-atc-add]');
  var atcSold = atc && atc.querySelector('[data-atc-soldout]');
  function setAvailability(ok) {
    if (atc) {
      atc.disabled = !ok;
      if (atcAdd) atcAdd.hidden = !ok;
      if (atcSold) atcSold.hidden = ok;
    }
    var sb = document.querySelector('[data-hl-atc-sticky]');
    if (sb) { sb.disabled = !ok; sb.textContent = ok ? 'Add to cart' : 'Sold out'; }
  }

  // option buttons
  form.querySelectorAll('.opt__btns').forEach(function (group) {
    group.querySelectorAll('.opt__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.opt__btn').forEach(function (x) { x.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var oi = parseInt(btn.getAttribute('data-opt'), 10);
        selected[oi] = btn.getAttribute('data-value');
        var lab = form.querySelector('[data-opt-current="' + oi + '"]');
        if (lab) lab.textContent = btn.textContent;
        update();
      });
    });
  });
  update();

  // gallery thumbnails — image swaps the <img> src, video reveals its own player
  document.querySelectorAll('.thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-media-type') === 'video') {
        showVideo(b.getAttribute('data-media-id'));
      } else {
        showImage();
        var full = b.getAttribute('data-full');
        if (mainImg && full) mainImg.src = full;
      }
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
    });
  });

  // sticky ATC — show whenever the main Add-to-cart is off-screen
  var sticky = document.getElementById('stickybar');
  if (atc && sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        sticky.classList.toggle('show', !en.isIntersecting);
        sticky.setAttribute('aria-hidden', en.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    io.observe(atc);
  }
  var stickyBtn = document.querySelector('[data-hl-atc-sticky]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }
})();
